import type { ReaderItem } from "../types";
import { publicationDate, validReadingCopy } from "../readingCopy";

export function ArticleDates({ item }: { item: ReaderItem }) {
  // Old cached published_at could be a save-time fallback. Only an explicitly
  // qualified reading copy is a safe legacy publication source.
  const published = item.article_dates ? item.article_dates.published?.value
    : validReadingCopy(item.reading_copy) ? item.reading_copy.published_date : undefined;
  const dates = [
    ["Published", published],
    ["Updated", item.article_dates?.modified?.value],
    ["Saved", item.created_at],
  ].filter((entry): entry is [string, string] => typeof entry[1] === "string" && Boolean(publicationDate(entry[1])));
  if (!dates.length) return null;
  return <div className="article-dates" aria-label="Article dates">
    {dates.map(([label, value]) => <span key={label}>{label} <time dateTime={value} title={value}>{label === "Saved" && Number.isFinite(Date.parse(value))
      ? new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric" }).format(new Date(value))
      : publicationDate(value)}</time></span>)}
  </div>;
}
